import React, { useState } from "react";
import "./styles.scss";
import { Modal, Backdrop } from "@mui/material";
import { Clear } from "@mui/icons-material";
import Button from "../../../common/button";
import Checkbox from "../../../common/checkbox";
import { useStateValue } from "../../../store";
import { useNavigate } from "react-router-dom";

const CartPopup = () => {
  const [open, setOpen] = useState(true);
  const [{ cartAlert }, dispatch] = useStateValue();
  const Navigate = useNavigate();
  const { bundle_details, identity, message, data, status } =
    cartAlert?.alertData;
  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    else {
      setOpen(false);
      dispatch({
        type: "SET_CART_ALERT",
        value: false,
        data: {},
      });
    }
  };

  const bundleData = [
    {
      title: bundle_details?.name,
      description: bundle_details?.description,
      term_id: "1",
    },
  ];

  const handleProceedBack = () => {
    dispatch({
      type: "SET_CART_ALERT",
      value: false,
      data: {},
    });
    setTimeout(() => {
      Navigate(`${process.env.REACT_APP_BASE}/bundle`);
    }, [500]);
  };
  //navigate router
  const handleNavigate = () => {
    dispatch({
      type: "SET_CART_ALERT",
      value: false,
      data: {},
    });
    setTimeout(() => {
      Navigate(`${process.env.REACT_APP_BASE}/mycart`);
    }, [500]);
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      disableAutoFocus={true}
      BackdropProps={{
        timeout: 500,
      }}
      className="cart-popup-container"
    >
      <div className="popup-container">
        <div className="title">
          <p>Your cart</p>
          <Clear className="clear-btn" onClick={() => handleClose()} />
        </div>
        <div className="add-message">{message}</div>
        {status === false ? (
          ""
        ) : (
          <div className="product-section">
            {identity === "single" && (
              <div className="product-details">
                <div className="image">
                  <img
                    src={data?.variant_details?.variation_image}
                    alt={`product_image`}
                  />
                </div>
                <div className="details">
                  <p className="title">{data?.product_details?.product_name}</p>
                  {data?.variant_details?.variation_name?.length &&
                    data.variant_details.variation_name.map((item) => {
                      return (
                        <>
                          {item?.attribute_name?.length &&
                            item?.option_name?.length && (
                              <p className="accessory">
                                <span className="accessory-tile">
                                  {item?.attribute_name}
                                  <span className="accessory-info">
                                    {item?.option_name
                                      ? `: ${item?.option_name}`
                                      : ""}
                                  </span>
                                </span>
                              </p>
                            )}
                        </>
                      );
                    })}
                  <p className="amount">
                    {`$`}
                    {data?.variant_details?.display_price}{" "}
                    {data?.variant_details?.currency}
                  </p>
                </div>
              </div>
            )}

            {identity === "bundle" && bundleData?.length ? (
              <Checkbox data={bundleData} status={true} />
            ) : (
              ""
            )}
          </div>
        )}
        <div className="add-product-btn ">
          <Button onClick={() => handleNavigate()}>Go to cart</Button>
          <p onClick={() => handleProceedBack()}>Continue shopping</p>
        </div>
      </div>
    </Modal>
  );
};

export default CartPopup;
